import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listInvoices(filters = "") {
    return this.http.get(this.api+`/nota-fiscal${filters}`);
  }
}
